import { BookmarkEnd, BookmarkStart } from 'docx';
import type { NodeEntry } from 'slate';

import type { BookmarkMarkerElement } from '../../../slate-api';

export function createBookmarkMarker([bookmarkMarker]: NodeEntry<BookmarkMarkerElement>):
  | BookmarkStart
  | BookmarkEnd {
  switch (bookmarkMarker.type) {
    case 'bookmarkStart':
      return new BookmarkStart(bookmarkMarker.name, bookmarkMarker.markerId);

    case 'bookmarkEnd':
      return new BookmarkEnd(bookmarkMarker.markerId);
  }
}
